export type SocialPlacement = MetaPlacement | TiktokPlacement;

export enum MetaPlacement {
    Instagram = 'meta-instagram',
    Facebook = 'meta-facebook',
    Messenger = 'meta-messenger',
    FacebookReels = 'meta-facebookreels',
    InstagramReels = 'meta-instagramreels',
}

export enum TiktokPlacement {
    Default = 'tiktok-default',
    After9s = 'tiktok-after-9s',
    After9sWithCard = 'tiktok-after-9s-with-card'
}

export enum SocialNetworkType {
    Meta = 'meta',
    TikTok = 'tiktok'
}

export interface ISocialPlacement {
    type: SocialPlacement;
    text: string;
    position: PlacementPostion;
}

export interface ISocialNetwork {
    type: SocialNetworkType;
    text: string;
    icon: string;
    placements: ISocialPlacement[];
    placementText: string;
    ratios: string[];
}

export interface ISocialGuide {
    network: ISocialNetwork;
    placement: ISocialPlacement;
    overlay: boolean;
    guidelines: boolean;
}

export interface ICreativeSocialGuide {
    network: SocialNetworkType;
    placement: SocialPlacement;
    overlay: boolean;
    guidelines: boolean;
}

export interface PlacementPostion {
    top: number;
    bottom: number;
    left?: number;
    right?: number;
}

const DEFAULT_PLACEMENT_POSITION: PlacementPostion = { top: 0.14, bottom: 0.14 };

const META_PLACEMENTS = [
    {
        type: MetaPlacement.Instagram,
        text: 'Instagram Story',
        position: DEFAULT_PLACEMENT_POSITION
    },
    {
        type: MetaPlacement.Facebook,
        text: 'Facebook Story',
        position: DEFAULT_PLACEMENT_POSITION
    },
    {
        type: MetaPlacement.Messenger,
        text: 'Messenger Story',
        position: DEFAULT_PLACEMENT_POSITION
    },
    {
        type: MetaPlacement.FacebookReels,
        text: 'Facebook Reels',
        position: { top: 0.12, bottom: 0.21, left: 0.07, right: 0.14 }
    },
    {
        type: MetaPlacement.InstagramReels,
        text: 'Instagram Reels',
        position: { top: 0.12, bottom: 0.21, left: 0.07, right: 0.13 }
    }
];

const TIKTOK_PLACEMENTS = [
    {
        type: TiktokPlacement.Default,
        text: 'Default',
        position: { top: 0.11, bottom: 0.17, left: 0.11, right: 0.15 }
    },
    {
        type: TiktokPlacement.After9s,
        text: 'After 9s',
        position: { top: 0.11, bottom: 0.22, left: 0.11, right: 0.15 }
    },
    {
        type: TiktokPlacement.After9sWithCard,
        text: 'After 9s with card',
        position: { top: 0.11, bottom: 0.25, left: 0.11, right: 0.15 }
    },
];

export const SOCIAL_PLACEMENTS = [
    ...META_PLACEMENTS,
    ...TIKTOK_PLACEMENTS
];

export const SOCIAL_NETWORKS: ISocialNetwork[] = [
    {
        type: SocialNetworkType.Meta,
        text: 'Meta',
        icon: 'meta',
        placementText: 'Placement',
        placements: META_PLACEMENTS,
        ratios: ['9:16']
    },
    {
        type: SocialNetworkType.TikTok,
        text: 'TikTok',
        icon: 'tiktok',
        placementText: 'CTA Style',
        placements: TIKTOK_PLACEMENTS,
        ratios: ['9:16']
    }
];
